import React from 'react';
import { Grid, TextArea, Form, Dropdown, Label, Checkbox } from 'semantic-ui-react';
import InputField from 'common/InputField';
import ScriptEditor from './ScriptEditor';
import { itemTypesOptions, targetTypesOptions } from 'common/options';

const ItemEditor = function(props) {
  const item = props.item;
  const change = props.onChange;

  return (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={16}>
        <Form>
          <Label>Description</Label>
          <TextArea value={item.Description}
                    onChange={(e,d) => change('Description')(d.value)}
                    placeholder='Item Description'/>
        </Form>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row verticalAlign='bottom'>
      <Grid.Column width={3}>
        <Label>Item type</Label>
        <Dropdown options={itemTypesOptions}
                  search
                  fluid
                  selection
                  value={item.ItemType}
                  onChange={(e,d) => change('ItemType')(d.value)} />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={item.Gold}
                    onChange={change('Gold')}
                    type='int'
                    fluid
                    label='Gold'
                    placeholder='Gold' />
      </Grid.Column>
      <Grid.Column width={3}>
        <Checkbox label='Identified'
                  checked={item.Identified}
                  onChange={() => change('Identified')(!item.Identified)} />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={item.Damage}
                    onChange={change('Damage')}
                    type='dice'
                    fluid
                    label='Damage'
                    placeholder='Ex. 1d6+2'
                    optional />
      </Grid.Column>
      <Grid.Column width={2}>
        <InputField value={item.Armor}
                    onChange={change('Armor')}
                    type='int'
                    fluid
                    label='Armor'
                    placeholder='Armor'
                    optional />
      </Grid.Column>
      <Grid.Column width={2}>
        <InputField value={item.ArmorPenalty}
                    onChange={change('ArmorPenalty')}
                    type='int'
                    fluid
                    label='Armor penalty'
                    placeholder='Armor penalty'
                    optional />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={3}>
        <InputField value={item.Uses}
                    onChange={change('Uses')}
                    fluid
                    label='Uses'
                    placeholder='Number or "unlimited"'
                    optional />
      </Grid.Column>
      <Grid.Column width={3}>
        <Label>Target type</Label>
        <Dropdown options={targetTypesOptions}
                  search
                  fluid
                  selection
                  clearable
                  placeholder='Target for OnUse'
                  value={item.TargetType}
                  onChange={(e,d) => change('TargetType')(d.value)} />
      </Grid.Column>
      <Grid.Column width={10}>
        <Label>OnUse</Label>
        <ScriptEditor src={item.OnUse}
                      onSave={change('OnUse')} />
      </Grid.Column>
    </Grid.Row>
  </React.Fragment>
  );
}

export default ItemEditor;
